module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_M1-8ea4f595c3bee443bec59f76a6d46116.webp";